module.exports = __webpack_public_path__ + "static/job-finding-app-tablet-plp-a42723c2afc44638727d1c4123023b16.png";